import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-JKNLPCbR.mjs"));
export {
  FilePickerVue
};
//# sourceMappingURL=index-BMbtc3xh.mjs.map
